import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class StrategiesService {
  constructor(private global: GlobalService) {}

  getAll(): Observable<any> {
    return this.global.get('/SP-GetAllStrategies/');
  }

  getById(id: string): Observable<any> {
    return this.global.post('/SP-GetStrategieById/', { id });
  }

  add(data: any): Observable<any> {
    return this.global.post('/SP-AddStrategie/', data);
  }

  update(data: any): Observable<any> {
    return this.global.post('/SP-UpdateStrategie/', data);
  }

  delete(data: any): Observable<any> {
    return this.global.post('/SP-DeleteStrategie/', data);
  }

  toggleArchive(data: any): Observable<any> {
    return this.global.post('/SP-ToggleArchiveStrategy/', data);
  }
}
